var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22748 16.7729C6.93459 16.48 6.93459 16.0052 7.22748 15.7123L15.7128 7.22699C16.0057 6.9341 16.4805 6.9341 16.7734 7.22699C17.0663 7.51989 17.0663 7.99476 16.7734 8.28765L8.28814 16.7729C7.99525 17.0658 7.52038 17.0658 7.22748 16.7729Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22748 7.22699C7.52038 6.9341 7.99525 6.9341 8.28814 7.22699L16.7734 15.7123C17.0663 16.0052 17.0663 16.48 16.7734 16.7729C16.4805 17.0658 16.0057 17.0658 15.7128 16.7729L7.22748 8.28765C6.93459 7.99476 6.93459 7.51989 7.22748 7.22699Z",
    fill: "#ABABAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDocument);
export default __webpack_public_path__ + "static/media/delete_document.b1f4dc51633629b5378f3d53977e6230.svg";
export { ForwardRef as ReactComponent };